module.exports = __webpack_public_path__ + "static/media/comment_smile.0ac22454.svg";